import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { distinct, forEach, map, sortWithUndefined } from '@beef/utils';
import { getClosestOfKeys, sizeToPixelSort } from '@beefco/core/utils';
import { AdaptiveSizeNames, PARAM_EMPTY_VALUE } from '@beefco/core';
import { fillCoreParentIds } from "./utils";
import { NodeTreeSlice } from "./NodeTreeSlice";
var collectPropValues = function collectPropValues(props, slug) {
  return distinct(props.map(function (item) {
    return item[slug];
  }));
};

/* eslint-disable-next-line react/no-children-prop */
var UnknownComponent = function UnknownComponent() {
  return /*#__PURE__*/React.createElement('div', {
    children: 'Unknown component'
  });
};
export var NodeTreeFacade = /*#__PURE__*/function () {
  function NodeTreeFacade(coreDSL, components) {
    _classCallCheck(this, NodeTreeFacade);
    this.components = components;
    _defineProperty(this, "slice", void 0);
    _defineProperty(this, "dependencies", void 0);
    _defineProperty(this, "coreDSL", void 0);
    this.coreDSL = fillCoreParentIds(coreDSL || {});
  }
  _createClass(NodeTreeFacade, [{
    key: "filterBySize",
    value: function filterBySize(prop, currentSize) {
      var sortedSizes = sortWithUndefined(distinct(prop.map(function (item) {
        return item.size;
      })), sizeToPixelSort);
      var closestSize = getClosestOfKeys(sortedSizes, currentSize || AdaptiveSizeNames.GLOBAL);
      var filteredProps = prop.filter(function (_ref) {
        var _ref$size = _ref.size,
          size = _ref$size === void 0 ? AdaptiveSizeNames.GLOBAL : _ref$size;
        return size === closestSize;
      });
      return filteredProps.length ? filteredProps : [undefined];
    }
  }, {
    key: "getTreeSlice",
    value: function getTreeSlice(params) {
      var _this = this;
      var dependencies = JSON.stringify(params);
      if (this.dependencies !== dependencies) {
        this.dependencies = dependencies;
        var unpackProp = function unpackProp(prop, defaultValue) {
          return _objectSpread({
            value: defaultValue
          }, _this.filterBySize(prop, params.size)[0]);
        };
        this.slice = new NodeTreeSlice(map(this.coreDSL, function (node) {
          return {
            componentId: node.componentId,
            Component: _this.components[node.componentId] || UnknownComponent,
            active: unpackProp(node.active || [], true),
            props: map(node.props || {}, function (value) {
              return unpackProp(value);
            }),
            styles: map(node.styles || {}, function (value) {
              return unpackProp(value).value;
            }),
            children: map(node.children || {}, function (value) {
              return unpackProp(value, []).value;
            }),
            parentId: node.parentId ? unpackProp(node.parentId).value : null
          };
        }));
      }
      return this.slice;
    }
  }, {
    key: "iterateParamProps",
    value: function iterateParamProps(cb) {
      forEach(this.coreDSL, function (node) {
        cb(node.active || []);
        forEach(node.props || {}, cb);
        forEach(node.styles || {}, cb);
        forEach(node.children || {}, cb);
      });
    }
  }, {
    key: "extractUniqueParamValues",
    value: function extractUniqueParamValues(paramSlug) {
      var resolutions = [PARAM_EMPTY_VALUE];
      this.iterateParamProps(function (paramProps) {
        resolutions = distinct([].concat(_toConsumableArray(resolutions), _toConsumableArray(collectPropValues(paramProps, paramSlug))));
      });
      return sortWithUndefined(resolutions, sizeToPixelSort).reverse();
    }
  }]);
  return NodeTreeFacade;
}();